<template>
    <div class="app-luck-draw">

        <van-nav-bar :title="$t('luckDraw.title')" class="app-nav-bar">
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
            <!-- <template #right>
                <div class="app-right">中奖记录</div>
            </template> -->
        </van-nav-bar>



        <div class="prize-draw-page__big-wheel-box" v-if="prizeList.length">

            <big-wheel width="300px" height="300px" ref="bigWheel" :prizeList="prizeList" @over="over">
                <template v-slot:item="{ item }">
                    <div class="prize-draw-page__prize-name">{{ item.title }}</div>
                    <img class="prize-draw-page__prize-img" :src="item.image">
                </template>
            </big-wheel>
            <!-- 开始按钮 -->
            <img class="prize-draw-page__btn-go" @click="go" :src="require('@/assets/images/shared/go.png')" />
        </div>

        <div class="prize-draw-page__bullet">
            <div class="prize-draw-page__bullet-inner">
                <div class="prize-draw-page__bullet-wrap">
                    <div class="prize-draw-page__flex-box-x app-list" v-for="( item, index ) in  luckdrawlog " :key="index">
                        <div class="col-xs-x">
                            <img class="prize-draw-page__img" width="40px" height="40px" :src="item.image" alt="">

                            <div class="van-ellipsis"> {{ item.mmname }}</div>
                        </div>
                            <div class="col-xs-x van-ellipsis"> {{ item.username }}</div>
                        <div class="col-xs-x">{{ item.add_time | dateFormat }}</div>
                        <!-- <div class="col-xs-x"> {{ item.money }} {{$t('reservation.unit')}}{{$t('my.balance')}}</div> -->
                    </div>
                </div>
            </div>
        </div>
        <van-popup v-model="show" class="prize-draw-page__popup-show" :close-on-click-overlay="false">
            <template v-if="prizeInfo">

                <img class="prize-draw-page__img" :src="prizeInfo.image" alt="">
                <div class="app-title">{{ prizeInfo.title }}</div>
                <div class="prize-draw-page__msgmemo" v-html="msgmemo"></div>
            </template>

            <div class="prize-draw-page__btn" @click="clearInfo()">{{ $t('setting.ok') }}</div>
        </van-popup>
    </div>
</template>

<script>
import BigWheel from '../BigWheel/BigWheel.vue';
export default {
    components: {
        BigWheel
    },
    data() {
        return {

            prizeList: [
            ],
            valve: false, // 防止连续点击
            show: false,
            prizeInfo: null,
            msgmemo: '',
            luckdrawlog: []
        };
    },
    created() {
        this.$http({
            method: 'post',
            url: 'luckdrawlist'
        }).then(res => {
            if (res.code === 200) {
                this.prizeList = res.data
            } else if (res.code === 401) {
                this.$toast(res.msg);
            }
        })

        this.$http({
            method: 'post',
            url: 'luckdrawlog'
        }).then(res => {
            if (res.code === 200) {
                this.luckdrawlog = res.data
            } else if (res.code === 401) {
                this.$toast(res.msg);
            }
        })

    },

    filters: {
        dateFormat(val) {
            // 先把传参毫秒转化为new Date()
            const dt = new Date(val * 1000)
            const y = dt.getFullYear()
            // 月份是从0开始,需要+1
            // +''是把数字转化为字符串,padStart(2,'0')是把字符串设置为2位数,不足2位则在开头加'0'
            const m = (dt.getMonth() + 1 + '').padStart(2, '0')
            const d = (dt.getDate() + '').padStart(2, '0')
            return `${m}/${d}/${y}`
        }
    },

    methods: {
        clearInfo() {
            this.show = false
            this.prizeInfo = null
        },
        back() {
            return window.history.back();
        },
        // 开始转动
        go() {
            if (this.valve) {
                return
            }
            this.valve = true
            this.$http({
                method: 'post',
                url: 'luckdraw'
            }).then(res => {
                if (res.code === 200) {
                    // // 转动转盘
                    this.prizeList.map((item, index) => {
                        if (item.id == res.data.id) {
                            this.winningIndex = index
                        }
                    })
                    this.$refs.bigWheel.rotate(this.winningIndex)
                    console.log(res.data)
                    this.msgmemo = res.data.msgmemo
                } else {
                    this.$toast(res.msg);
                }
            })
        },
        // 转盘转完事件
        over(prizeInfo) {
            this.valve = false
            this.prizeInfo = prizeInfo
            this.show = true
        },


    }
};
</script>

<style scoped lang="less" src="./index.styles.less"></style>